import { ReportComment } from "@app/features/panels/service/comments.service";

export interface IReport {
  id: number;
  uuid: string;
  title: string;
  width: number;
  height: number;
  url: string;
  widthUnit: 'px' | '%';
  heightUnit: 'px' | '%';
  visible: boolean;
  categories?: ReportCommentCategory[];
  comments?: ReportComment[];
  createdAt?: string | Date;
}

export type ReportCommentCategory = {
  id?: number;
  name: string;
  reportId?: number;
  createdAt?: string;
  updatedAt?: string;
};

export interface ICreateReportRequest {
  title: string;
  url: string;
  width: number;
  height: number;
}

export interface IUpdateReportRequest extends ICreateReportRequest {
  id: number;
}
